import Model, { attr } from '@ember-data/model';

/**
 * @classdesc
 * Model for storing Self-Guided Tours phone verification info for guest checkout.
 */
export default class PhoneVerificationGuest extends Model {
    /**
     * The JWT used to store information for guest checkouts and appointments
     */
    @attr('string') declare jwt: string;

    /**
     * The code the user has entered.
     */
    @attr('string') declare userEnteredCode: string;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
    export default interface ModelRegistry {
        'phone-verification-guest': PhoneVerificationGuest;
    }
}
